import React from "react";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import ProcessFollow from "../../components/ProcessFollow.js";
import { Helmet } from "react-helmet-async";

const FullStackDev = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Looking for expert Full Stack developers in Noida, Delhi NCR? Ayanshtech Solutions builds fast, secure, and scalable websites that drive leads and conversions."
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="Full Stack Development Company Noida Delhi Ncr | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/fullstack-dev"
        />
        <meta
          property="og:description"
          content="Looking for expert Full Stack developers in Noida, Delhi NCR? Ayanshtech Solutions builds fast, secure, and scalable websites that drive leads and conversions."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="Full Stack Development Company Noida Delhi Ncr | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Looking for expert Full Stack developers in Noida, Delhi NCR? Ayanshtech Solutions builds fast, secure, and scalable websites that drive leads and conversions."
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link
          rel="canonical"
          href="https://ayanshtechnology.com/fullstack-dev"
        />
        <title>
          Full Stack Development Company Noida Delhi Ncr | Ayanshtech Solutions
        </title>
      </Helmet>
      <div className="flex flex-col items-center justify-center mb-6 py-6">
        <div className=" py-5 px-5 w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
            <div className="lg:w-3/4 text-center lg:text-left p-6">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                Full Stack Development Company in Noida, Delhi NCR
              </h1>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Revolutionize your digital presence with Ayanshtech Solutions, a
                leading Full Stack Development Company in Noida, Delhi NCR. We
                specialize in delivering end-to-end web development solutions
                that empower businesses with dynamic, scalable, and
                high-performing applications. From intuitive front-end
                interfaces to robust back-end architectures, our expert
                developers ensure seamless integration, top-notch functionality,
                and exceptional user experience.
                <br />
                Our full stack development services cover the complete
                technology spectrum — from modern front-end frameworks like
                React, Angular, and Vue.js to powerful back-end technologies
                such as Node.js, Express.js, and databases including MongoDB,
                MySQL, and PostgreSQL. Whether you’re building a custom web
                application, integrating third-party APIs, or enhancing system
                performance, our team crafts tailored solutions to meet your
                business goals.
                <br />
                Partner with Ayanshtech Solutions to experience innovative,
                efficient, and future-ready web applications that drive growth
                and engagement. Let’s build your next digital success story with
                our full stack development expertise in Delhi NCR.
              </p>

              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center mb-12 lg:mb-0 mt-5">
              <img
                src="\assets\images\webAppDev\fullstack1.avif"
                alt="Full Stack Development Company"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="text-center mb-5 p-6">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Our Full Stack Development Services
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Build scalable, robust, and high-performance web applications with
            full-stack solutions that streamline your operations and enhance
            user experience.
          </p>
        </div>

        <div className=" ml-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">End-to-End Web Development</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">API Development and Integration</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Database Architecture & Management</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Cross-Platform App Development</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Scalable Backend Solutions</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Version Control (Git, GitHub)</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Cloud Deployment (AWS, Azure)</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Continuous Integration & Deployment</p>
            </div>
          </div>
        </div>
        <div className=" ">
          <div className="">
            <div className="text-center mt-10 mb-4 p-6">
              <h2 className="font-bold text-gray-800 mb-2 sm:text-3xl md:text-4xl lg:text-6xl">
                Technology Expertise
              </h2>
            </div>
            <div className="flex justify-center">
              <div className="overflow-hidden max-w-7xl">
                <div className="flex animate-scroll-left gap-6">
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/nodeJs.svg"
                      alt="Angular Js"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/angularJs.svg"
                      alt="AngularJs"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/laravel.png"
                      alt="Laravel"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/flutter.svg"
                      alt="Flutter"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/kotlin.svg"
                      alt="Kotlin"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>

                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/magento.svg"
                      alt="Magento"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/mongoDb.svg"
                      alt="mongoDB"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/mySql.svg"
                      alt="mysql"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/nextJs.svg"
                      alt="Laravel"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/php.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/postgreSql.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/react.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/swift.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>

                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/vite.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/vueJs.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/wordPress.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-10 p-4">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Why Choose Our Full Stack Development Services?
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Leverage the power of full-stack development to build feature-rich,
            scalable, and reliable web applications for your business needs.
          </p>
        </div>

        <div className=" p-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="\assets\images\webAppDev\fullstack2.avif"
                alt="Full Stack Development Demo"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon1.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    End-to-end development with seamless integration
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon2.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Scalable and secure backend solutions
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon3.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Real-time application development with WebSockets
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon4.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Cross-platform compatibility and responsive design
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon5.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    API development and integration with third-party services
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon6.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Cloud-based deployment for scalability and performance
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ProcessFollow />

        <AyanshtechAdvantage />

        <div id="contact-section">
          <Contact />
        </div>

        <GetInTouch />
      </div>
    </>
  );
};

export default FullStackDev;
